import React from 'react'

import { ReactComponent as Eye } from '../../../../assets/svgs/eye.svg'

export const EyeIcon = ({ width = 24, height = 24, ...restProps }) => (
  <Eye
    width={width}
    height={height}
    aria-hidden="true"
    focusable="false"
    {...restProps}
  />
)
